module.exports = __webpack_public_path__ + "img/c1f75b5.png";